import React from 'react';

const TypingIndicator = React.memo(function TypingIndicator() {
  return (
    <div
      className="flex items-start mb-4"
      role="status"
      aria-live="polite"
      aria-label="Agent is typing"
    >
      <div className="max-w-[80%] rounded-lg px-3 py-2 bg-white border border-gray-200">
        <span className="typing-dot" aria-hidden="true" />
        <span className="typing-dot" aria-hidden="true" />
        <span className="typing-dot" aria-hidden="true" />
      </div>
    </div>
  );
});

export default TypingIndicator;
